export default "__VITE_ASSET__yQ5Mw_tp$C5jgqb_o_VSHg__ 480w, __VITE_ASSET__5ueHAtn9JtiQ3lCiqsnAfg__ 768w, __VITE_ASSET__WFHrEU78LbAH0OIV$gG5mg__ 1122w";